"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Icon_1 = require("../Icon");
/*eslint-disable */
/*tslint:disable */
var Check = function (props) { return (React.createElement(Icon_1.default, tslib_1.__assign({ viewBox: "0 0 16 12" }, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M14.314 1.713l.322-.344v-.026l-.337.356.015.014zm-13 4.69l.001.025.37.296.011-.014-.383-.307zM14.28.287l1.421 1.379-9.393 10.013L.304 6.876l1.212-1.568 4.602 3.68L14.28.288z", fill: "currentColor", fillRule: "evenodd" })))); };
/*tslint:enable */
/*eslint-enable */
exports.default = Check;
//# sourceMappingURL=Check.js.map